import { useNuxtApp, useRoute, useRouter } from '#app'
import { CallbackProps } from '@/services/vkAuth/vkAuth.types'
import { useUserStore } from '@/store/user/user'

export const authByVk = async ({ uuid, token, first_name }: CallbackProps) => {
  const { $sentryCaptureException } = useNuxtApp()
  const { $metrics } = useNuxtApp()
  const { name } = useRoute()
  const { go } = useRouter()
  const { authByVk } = useUserStore()

  const result = await authByVk({
    uuid,
    token,
    first_name,
  })

  if (result instanceof Error) {
    $sentryCaptureException(result)

    // await this.$store.dispatch('openSnackbar', {
    //   message: 'Что-то пошло не так',
    //   type: 'error',
    // })

    return
  }

  $metrics?.eventSendGoal({ ym: 'vk_auth' })

  name === 'login' ? (window.location.href = window.location.origin) : go(0)
}
